import doc                      from '@widesk-core/decorators/doc';
import model                    from '@widesk-core/decorators/model';
import NetworkServiceModel      from '@/models/NetworkServiceModel';
import ContactModel             from './ContactModel';
import RelationModel            from './RelationModel';

@model.urnResource('relation_contact')
@doc.path('/relation_contacts/{?id}')
export default class RelationContactModel extends NetworkServiceModel {
	private declare _tsFilters: {
		"id": id;
		"contact": id;
		"relation": id;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'updatedAt': string;
	};

	@doc.model(ContactModel) declare contact: ContactModel;
	@doc.model(RelationModel) declare relation: RelationModel;
}